module.exports = __webpack_public_path__ + "img/together1.ab73baec.jpg";